/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFunRunEventTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFunRunEvent,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Have Fun at the Run!",
    "Fun Run Event Awaits!",
    "Run Together and Have Fun!",
  ],
  title: "Fun Run Event",
  description: "Organize a fun run event.",
  longDescription:
    "Gather your community for an exciting fun run event! Choose a date, decide on routes, and plan refreshments!",
  emoji: "🏃",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Fun Run Event",
          emoji: "🏃",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the fun run event?",
          emoji: "📅",
          completeAction: {
            question: "Decide on running routes?",
            description: "What routes should we focus on during the event?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What routes should we consider?",
                emoji: "🏞",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we prepare for the participants?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Run Together!",
    outroDescription: "Your fun run event plans are set! Enjoy the run!",
  },
};
